import { useState } from "react";
import { ewaiverApi } from "../api/ewaiver.service";

export const useUpdateEwaiverStatus = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const updateStatus = async (id: string, status: boolean) => {
    setLoading(true);
    setError(null);

    try {
      const res = await ewaiverApi.updateStatus(id, status);
      return res;
    } catch (err: any) {
      console.error(`Update e-waiver status failed:`, err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateStatus,
    loading,
    error,
  };
};
